import api from "../../../../Repository/Interceptor";

export const getPopupTextGet = async () => {
  try {
    const resp = await api.get("/dashboard/popup");

    return resp;
  } catch (error) {
    console.log("팝업내용 가져오기 Error : ", error);
    return error;
  }
};

export const postPopupTrue = async (id) => {
  try {
    const resp = await api.post(`/dashboard/popup/${id}`);
    return resp;
  } catch (error) {
    console.log("동의 처리 Error : ", error);
    return error;
  }
};
